<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title ">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref ="form"
          >
            <el-form-item
              label="商户名称"
              prop="name"
            >
              <el-input
                v-model.trim="form.name"
                placeholder="请输入"
                maxlength="64"
                onkeyup="this.form.name=this.form.name.replace(/\s+/g,'')"
                show-word-limit
              ></el-input>

            </el-form-item>
            <el-form-item
              label="商户编码"
              prop="code"
            >
              <el-input
                v-model.trim="form.code"
                onkeyup="this.form.code=this.form.code.replace(/\s+/g,'')"
                placeholder="请输入"
                maxlength="32"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="手机"
              prop="phone"
            >
              <el-input
                v-model="form.phone"
                placeholder="请输入"
              >
                <el-select
                  style="width: 100px;"
                  class="phoneTitle"
                  v-model="form.nationCode"
                  slot="prepend"
                  filterable
                  placeholder="请选择"
                  :filter-method="dataFilter"
                >
                  <el-option
                    v-for="item in phoneList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                    <span>{{`${item.label} ${item.description}`}}</span>
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item
              label="通知url"
              prop="url"
            >
            <el-input
              v-model="form.url"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
            <el-form-item
              label="有效期至"
              prop="date"
            >
<!--              -->
              <el-date-picker
                style="width: 100%"
                type="date"
                :picker-options="expireTimeOption"
                v-model="form.date"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              class="blod-form-item"
              label="状态"
              prop="status"
            >
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="1"
              >启用</vs-radio>
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class=""
                :vs-value="0"
              >禁用</vs-radio>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>

  import { parseTime } from '@/utils/index';
  import { isMobile } from '@/utils/validate';
  import { getDictListByType } from '@/api/user'
  import { createMerchant,updateMerchant } from '@/api/merchan';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        name: "editOrAdd",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        editData:{
          type: Object,
          default(){
            return {
              departmentId: '',
              name: '',
              desc: '',
            }
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
          let _this = this;
          let validatorId = (rule, value, callback) => {
            if(value === ''){
              callback(new Error('请选择'));
            }else {
              callback();
            }
          };
        var validatePhone = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入手机号'));
          } else {
            if(_this.form.nationCode !== '+86'){
              callback();
            }else {
              if(!isMobile(value)){
                callback(new Error('请输入正确的手机号'));
              }else {
                callback();
              }
            }
          }
        };
        return {
          phoneList: [],
          phoneListMaster:[],
          expireTimeOption: {
            disabledDate(date) {
              //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
              return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
            }
          },
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          form:{
            name: '',
            code: '',
            nationCode: '+86',
            phone: '',
            url: '',
            date: '',
            status: 1,
          },
          rules:{
            // 名字有长度限制以及不能输入空格
            name:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            code:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            phone:[
              { validator: validatePhone, trigger: 'blur' }
            ],
            url:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            date:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
          }
        }
      },
      created(){
        this.getDictList();
      },
      watch: {
        editData(newValue, oldValue) {
          if(newValue.id){
            this.form.id = newValue.id;
            this.form.name = newValue.merName;
            this.form.code = newValue.merCode;
            this.form.code = newValue.merCode;
            this.form.nationCode = newValue.nationCode;
            this.form.phone = newValue.phone;
            this.form.url = newValue.notifyUrl;
            this.form.date = new Date(newValue.validDate.slice(0,10));
            this.form.status = newValue.merStatus;
          }else {
            this.form = {
              name: '',
              code: '',
              nationCode: '+86',
              phone: '',
              url: '',
              date: '',
              status: 1,
            }
          }
        },
        active(newValue){
          if(newValue){
            this.$refs.form.clearValidate();
          }
        }
      },
      computed: {
        title() {
          return this.isEdit ? '编辑商户': '添加商户';
        }
      },
      methods: {
        getDictList(){
          getDictListByType({
            type : 'phoneList'
          }).then((res) => {
            console.log(res);
            this.phoneList = res.data;
            this.phoneListMaster = res.data;
          })
        },
        dataFilter(val){
          this.form.nationCode = val;
          if (val) { //val存在
            this.phoneList = this.phoneListMaster.filter((item) => {
              if((item.label.indexOf(val) > -1) || (item.description.toUpperCase().indexOf(val.toUpperCase()) > -1)){
                return true
              }
            })
          } else {
            //val为空时，还原数组
            this.phoneList = this.phoneListMaster;
          }
        },
        close(){
          this.reset();
          this.$emit('close')
        },
        reset(){
          this.form = {
            name: '',
            code: '',
            nationCode: '+86',
            phone: '',
            url: '',
            date: '',
            status: 1,
          };
        },
        closeHandle() {
          this.close();
          this.$refs.form.resetFields();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                // ajax
                let params = {
                  merName: this.form.name,
                  merCode: this.form.code,
                  nationCode: this.form.nationCode || '+86',
                  phone: this.form.phone,
                  notifyUrl: this.form.url,
                  validDate: parseTime(this.form.date),
                  merStatus: this.form.status,
                };
                if(this.isEdit){
                  params.id = this.form.id;
                  updateMerchant(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      // title:'注意',
                      text:'操作成功',
                      position: 'top-right'
                    })
                  })
                }else {

                  createMerchant(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      // title:'注意',
                      text:'操作成功',
                      position: 'top-right'
                    })
                  })
                }

              }else {

              }
            })
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
